import React from 'react';

import { Grid, InputAdornment, MenuItem } from '@material-ui/core';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { StyledTextField } from 'styles/admin';

import { ANSWER_TYPES, QUESTION_TYPES } from 'constants/ProjectConstants';
import { SearchIcon } from 'constants/icons';

import { StyledSelect } from './styles';

const SearchQuestions = ({ source, search, onSearchChange, drivers }) => {
  const questionTypes = QUESTION_TYPES[source];
  const answerTypes = ANSWER_TYPES[source];
  const showThirdColumn = ['review', 'engagement'].includes(source);
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  return (
    <SearchGrid container>
      <FlexGrid item xs={showThirdColumn ? 6 : 7}>
        <StyledTextField
          fullWidth
          style={{ width: '90%' }}
          type="text"
          name="searchText"
          margin="dense"
          variant="outlined"
          value={search.text}
          placeholder="Search questions"
          onChange={(e) => onSearchChange('text', e)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon size="tinier" />
              </InputAdornment>
            ),
          }}
        />
      </FlexGrid>
      <FlexGrid item xs={showThirdColumn ? 2 : 3}>
        <StyledSelect
          value={search.answerType || ''}
          variant="outlined"
          displayEmpty
          onChange={(e) => onSearchChange('answerType', e)}
        >
          <MenuItem value="" disabled>
            Answer
          </MenuItem>
          <MenuItem value="ALL">- All -</MenuItem>
          {answerTypes.map((answerType) => (
            <MenuItem value={answerType.value}>{answerType.label}</MenuItem>
          ))}
        </StyledSelect>
      </FlexGrid>
      {showThirdColumn && (
        <FlexGrid item xs={3}>
          {source === 'review' ? (
            <StyledSelect
              value={search.questionType || ''}
              variant="outlined"
              displayEmpty
              onChange={(e) => onSearchChange('questionType', e)}
            >
              <MenuItem value="" disabled>
                Type
              </MenuItem>
              <MenuItem value="ALL">- All -</MenuItem>
              {questionTypes.map((questionType) => (
                <MenuItem value={questionType.value}>
                  {questionType.label === 'Goal' ? moduleName : questionType.label}
                </MenuItem>
              ))}
            </StyledSelect>
          ) : (
            <StyledSelect
              value={search.driver || ''}
              variant="outlined"
              displayEmpty
              onChange={(e) => onSearchChange('driver', e)}
            >
              <MenuItem value="" disabled>
                Driver
              </MenuItem>
              <MenuItem value="ALL">- All -</MenuItem>
              {drivers.map((driver) => (
                <MenuItem value={driver.id}>{driver.displayName}</MenuItem>
              ))}
            </StyledSelect>
          )}
        </FlexGrid>
      )}
    </SearchGrid>
  );
};

const SearchGrid = styled(Grid)`
  padding: 1rem 1.5rem 0.5rem 1.5rem;
`;

const FlexGrid = styled(Grid)`
  display: flex;
  align-items: center;
`;

export default withRouter(SearchQuestions);
